<template>
    <path d="M2.667 13.333q-.55 0-.942-.391t-.392-.942V4q0-.55.392-.942T2.667 2.667h8q.55 0 .942.391t.392.942V7l2.1-2.1q.167-.167.367-.083t.2.317v5.733q0 .233-.2.317t-.367-.083L12 9V12q0 .55-.391.942t-.942.391z" />
</template>
